import React, { useState } from "react";
import { useSelector } from "react-redux";

import "./top.scss";

const TopBar = () => {
  const { user } = useSelector((state) => state.user);

  return (
    <div className="top-bar-ctr">
      <div className="details-container" style={{ borderRadius: '8px', padding: '0.75rem', fontWeight: 'bolder', backgroundColor: '#fdbc00', color: 'black' }}>{user.SAP_ID}</div>
    </div>
  );
};

export default TopBar;
